import React from 'react';
import PropTypes from 'prop-types';
import { Components, Theme } from 'versafleet-core';

const { Color } = Theme;

class VisualState extends React.Component {
  static getPrevState(state, jobType) {
    const prevStates = {
      Processing: null,
      Assigned: 'Processing',
      Collected: jobType === 'delivery' ? 'Assigned' : 'Arrived',
      Started: jobType === 'delivery' ? 'Collected' : 'Assigned',
      Arrived: 'Started',
      Delivered: jobType === 'delivery' ? 'Arrived' : 'Collected',
      Incomplete: jobType === 'delivery' ? 'Started' : 'Collected',
    };
    return prevStates[state];
  }

  static getNextState(state, jobType) {
    const nextStates = {
      Processing: 'Assigned',
      Assigned: jobType === 'delivery' ? 'Collected' : 'Started',
      Collected: jobType === 'delivery' ? 'Started' : 'Delivered',
      Started: 'Arrived',
      Arrived: jobType === 'delivery' ? 'Delivered' : 'Collected',
      Delivered: null,
      Incomplete: null,
    };
    return nextStates[state];
  }

  static getIconClassName(state) {
    const iconClassNames = {
      Processing: 'versa-waiting2',
      Assigned: 'versa-warehouse',
      Collected: 'versa-arrow-up',
      Started: 'versa-otw',
      Arrived: 'versa-waiting2',
      Delivered: 'versa-completed',
      Incomplete: 'versa-close',
    };
    return iconClassNames[state];
  }

  render() {
    const { jobType, taskState } = this.props;
    let state;
    switch (taskState) {
      case 'unassigned':
      case 'assigned':
      case 'waiting_for_acknowledgement':
      case 'declined':
        state = 'Processing';
        break;
      case 'acknowledged':
        state = 'Assigned';
        break;
      case 'collected':
        state = 'Collected';
        break;
      case 'started':
        state = 'Started';
        break;
      case 'arrived':
        state = 'Arrived';
        break;
      case 'successful':
        state = 'Delivered';
        break;
      case 'failed':
      case 'cancelled':
        state = 'Incomplete';
        break;
      default:
    }

    const prevState = this.constructor.getPrevState(state, jobType);
    const nextState = this.constructor.getNextState(state, jobType);
    const iconColor = state === 'Incomplete' ? Color.$gold : Color.$green;

    return (
      <div className="vf-visual-state">
        {
          prevState ? (
            <div className="vf-visual-state__icon-container vf-visual-state__icon-container--prev-next">
              <Components.CircleIcon
                className="vf-visual-state__icon vf-visual-state__icon--prev-next"
                iconClassName={this.constructor.getIconClassName(prevState)}
                innerIconColor={Color.$white}
                outerIconColor={Color.$teal04}
              />
              <div className="vf-visual-state__state vf-visual-state__state--prev-next">
                {prevState}
              </div>
            </div>
          ) : false
        }

        {
          prevState ? (
            <div className="vf-visual-state__line vf-visual-state__line--prev" />
          ) : false
        }

        <div className="vf-visual-state__icon-container">
          <Components.CircleIcon
            className="vf-visual-state__icon"
            iconClassName={this.constructor.getIconClassName(state)}
            innerIconColor={Color.$white}
            outerIconColor={iconColor}
          />
          <div className="vf-visual-state__state">
            {state}
          </div>
        </div>

        {
          nextState ? (
            <div className="vf-visual-state__icon-container vf-visual-state__icon-container--prev-next">
              <Components.CircleIcon
                className="vf-visual-state__icon vf-visual-state__icon--prev-next"
                iconClassName={this.constructor.getIconClassName(nextState)}
                innerIconColor={Color.$white}
                outerIconColor={Color.$neutral12}
              />
              <div className="vf-visual-state__state vf-visual-state__state--prev-next">
                {nextState}
              </div>
            </div>
          ) : false
        }

        {
          nextState ? (
            <div className="vf-visual-state__line vf-visual-state__line--next" />
          ) : false
        }
      </div>
    );
  }
}

VisualState.displayName = 'Visual Task Satte';

VisualState.propTypes = {
  jobType: PropTypes.string.isRequired,
  taskState: PropTypes.string.isRequired,
};

export default VisualState;
